"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * 反应
 * @param target
 * @param handler
 */
function defineReactive(target, handler) {
    return new Proxy(target || {}, {
        set: function (target, key, value, receiver) {
            if (handler.set) {
                handler.set.call(target, target, key, value, receiver);
            }
            return Reflect.set(target, key, value, receiver);
        },
        get: function (target, key, receiver) {
            if (handler.get) {
                handler.get.call(target, target, key, receiver);
            }
            return Reflect.get(target, key, receiver);
        },
        deleteProperty: function (target, key) {
            if (handler.deleteProperty) {
                handler.deleteProperty.call(target, target, key);
            }
            return Reflect.deleteProperty(target, key);
        }
    });
}
exports.default = defineReactive;
//# sourceMappingURL=define-reactive.js.map